
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { postData, getData } from '../../../../ApiServices/ApiService';
import {
    ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, ORG_GET_GROUP_ESTIMATE_TASK_LIST, ORG_GET_SERVICE_LIST_SEARCH, ORG_GET_SUB_SERVICE_LIST_SEARCH,
    ORG_GET_ESTIMATE_TASK_LIST,ORG_GET_RECURRUNG_INVOICE_LIST, ORG_INVOICE, ORG_GET_GROUP_LIST, ORG_GET_EMPLOYEE_LIST, ORG_GET_GROUP_INFO, ORG_CREATE_RECURRUNG_INVOICE, ORG_GET_INVOICE_INFO
} from '../../../../ApiServices/BaseURL';
import { useLocation } from 'react-router-dom';

const GenerateRecurringInvoiceController = () => {

    const location = useLocation();
    const rowData = location?.state?.rowData;
    const preSelectedInvoiceData = location?.state?.preInvoiceData;
    const [searchUser, setSearchUser] = useState('');
    const [clientList, setClientList] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);
    const [selectedClientError, setSelectedClientError] = useState('');
    const [loading, setLoading] = useState(false);

    const [groupInfo, setGroupInfo] = useState({});
    const [groupInfoError, setGroupInfoError] = useState('');
    const [groupInfoLoading, setGroupInfoLoading] = useState(false);

    const [taskListLoading, setTaskListLoading] = useState(false);
    const [taskList, setTaskList] = useState([]);
    const [taskListError, setTaskListError] = useState('');

    const [selectAll, setSelectAll] = useState(false);
    const [checkedStates, setCheckedStates] = useState([]);
    const [selectedTaskIds, setSelectedTaskIds] = useState([]);

    const [groupClientOptionsList, setGroupClientOptionsList] = useState([]);
    const [groupLoading, setGroupLoading] = useState(false);
    const [groupClientError, setGroupClientError] = useState('');
    const [groupClient, setGroupClient] = useState(null);

    const [groupTaskListLoading, setGroupTaskListLoading] = useState(false);
    const [groupTaskList, setGroupTaskList] = useState([]);
    const [groupTaskListError, setGroupTaskListError] = useState('');

    const [selectedClientsTasks, setSelectedClientsTasks] = useState({});
    const [dateError, setDateError] = useState('')

    const [expandedClients, setExpandedClients] = useState({});

    const [employeeList, setEmployeeList] = useState([]);
    const [empLoading, setEmpLoading] = useState(false);
    const [empError, setEmpError] = useState('');

    const [invoiceWithoutTask, setInvoiceWithoutTask] = useState(false);
    const [isRecurring, setIsRecurring] = useState(true);

    const [rows, setRows] = useState([
        { id: 1, serviceCategory: null, serviceType: [] }, // Default row
    ]);

    const [serviceOptions, setServiceOptions] = useState([]); // Service list
    const [serviceError, setServiceError] = useState('');
    const [serviceLoading, setServiceLoading] = useState(false);
    const [serviceCategoryOptions, setServiceCategoryOptions] = useState({}); // Map of serviceId -> serviceType options
    const [serviceCategoryError, setServiceCategoryError] = useState({});
    const [serviceCategoryLoading, setServiceCategoryLoading] = useState({});
    const [serviceSelectError, setServiceSelectError] = useState('')

    const [sendUpdateToClient, setSendUpdateToClient] = useState(false);
    const [sendUpdateToTeam, setSendUpdateToTeam] = useState(false);
    const [isShowGroupWise, setIsShowGroupWise] = useState('Client');
    const invoiceTableData = [
        {
            taskName: "GST Filling",
            financialYear: "2023-24",
            assignedTo: "Yearly",
            taskLeader: "Yearly",
            startDate: "11/11/2024",
            etd: "11/11/2024",
            status: "In Progress"
        },
        {
            taskName: "Company Reg",
            financialYear: "2023-24",
            assignedTo: "Yearly",
            taskLeader: "Yearly",
            startDate: "11/11/2024",
            etd: "11/11/2024",
            status: "Not Started"
        },
        {
            taskName: "Company Registration",
            financialYear: "2023-24",
            assignedTo: "Yearly",
            taskLeader: "Yearly",
            startDate: "11/11/2024",
            etd: "11/11/2024",
            status: "Priority"
        },
        {
            taskName: "ITR",
            financialYear: "2023-24",
            assignedTo: "Yearly",
            taskLeader: "Yearly",
            startDate: "11/11/2024",
            etd: "11/11/2024",
            status: "Priority"
        },
        {
            taskName: "Retention Charges",
            financialYear: "2023-24",
            assignedTo: "Monthly",
            taskLeader: "Monthly",
            startDate: "11/11/2024",
            etd: "11/11/2024",
            status: "Priority"
        }
    ]

    const [basicInformation, setBasicInformation] = useState({
        clientName: "",
        groupName: "",
        phoneNo: "",
        dateOfInvoice: "",
        countryCode: "",
    });

    const [submitLoading, setSubmitLoading] = useState(false);
    const [submitError, setSubmitError] = useState('');
    const [submitSuccess, setSubmitSuccess] = useState('');

    const [filedErrors, setFiledErrors] = useState({
        invoiceType: "",
        systemInvoicingAmount: "",
        invoiceAmount: "",
        noTaxInvoices: "",
        followUpDate: "",
        advancePayments: "",
        invoiceNo: "",
    })

    const handleBasicInformationChange = (field, value) => {
        setBasicInformation((prevInfo) => ({
            ...prevInfo,
            [field]: value,
        }));
        setDateError('');
    };

    const [invoiceDetails, setInvoiceDetails] = useState({
        invoiceType: null,
        noTaxInvoices: null,
        generateSeperateInvoices: null,
        estimateNumber: "",
        invoiceNo: '',
        advancePayments: null,
        systemInvoicingAmount: null,
        invoiceAmount: null,
        taskCompletedBy: null,
        generatedBy: null,
        organization: "",
        receiptBook: "",
        followUpDate: "",
        cgst: 0,
        sgst: 0,
        igst: 0,
        conveyanceFee: 0,
        discountAmount: 0,
        discountAmountPct: null,
        discountPct: 0,
        grandTotal: 0,
        payableAmt: 0,
        balanceAmt: 0
    });

    const [isCSGST, setIsCSGST] = useState(false);
    const [isIGST, setIsIGST] = useState(false);
    const [isConFee, setIsConFee] = useState(false);
    const [getValueInfo, setGetValueInfo] = useState({
        "series_type": 0,
        "acc_tax_sgst": 0,
        "acc_tax_cgst": 0,
        "acc_tax_igst": 0,
        "acc_tax_conv_fee": 0
    });
    const [gstValueInfoLoading, setGetValueInfoLoading] = useState(false);
    const [getValueInfoError, setGetValueInfoError] = useState('');

    const [convFeeError, setConvFeeError] = useState('')
    const [igstError, setIgstError] = useState('')
    const [sgstError, setSgstError] = useState('')
    const [cgstError, setCgstError] = useState('')
    const [discountError, setDiscountError] = useState('');

    const [invoiceInfo, setInvoiceInfo] = useState({});
    const [invoiceError, setInvoiceError] = useState('');
    const [invoiceLoading, setInvoiceLoading] = useState(false);
    const [isGenReceiptModalOpen, setIsGenReceiptModalOpen] = useState(false);

    useEffect(() => {
        fetchGroupList();
        fetchUserList();
        fetchServiceList();
    }, [])

    useEffect(() => {
        if (rowData) {
            fetchInvoiceInfo(rowData?.recurring_id)
        } else {

            fetchGstValueInfo();
        }
    }, [rowData])

    useEffect(() => {
        if (preSelectedInvoiceData) {
            if (preSelectedInvoiceData?.pageType === 'taskListPage') {
                handleTaskListPageData(preSelectedInvoiceData);
            } else {
                handleToSetPreSelectedData(preSelectedInvoiceData);
            }
        }

    }, [preSelectedInvoiceData])

    // Get Invoice Details 

    const fetchInvoiceInfo = async (invoiceId) => {
        try {
            setInvoiceError('');
            setInvoiceInfo({});
            setInvoiceLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
                "action": "recurring_inv_info",
                "recurring_id":invoiceId,
                "emp_id_auth": storedUserInfo?.emp_id
              }
            // Make the API call
            // const response = await getData(`${ORG_GET_INVOICE_INFO}?emp_id_auth=${storedUserInfo?.emp_id}&recurring_id=${invoiceId}`);
            const response = await postData(ORG_GET_RECURRUNG_INVOICE_LIST, payLoad);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            setInvoiceInfo(responseData?.dataJ[0]);
                            handleSetResponseData(responseData?.dataJ[0])
                        } else {
                            setInvoiceError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setInvoiceError(responseData?.info || 'Failed to fetch invoice data. Please try again.');
                    }
                } else {
                    setInvoiceError(responseData?.info || 'Failed to fetch invoice data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setInvoiceError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setInvoiceError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setInvoiceError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setInvoiceError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            setInvoiceError(`Failed to fetch invoice data. Please check your network connection and try again.`);

        } finally {
            setInvoiceLoading(false);
        }
    }

    const fetchGroupInfo = async (groupIdValue) => {
        try {
            setGroupInfoLoading(true);
            setGroupInfoError('');
            // setTeamInfo({});


            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_GROUP_INFO}?group_id=${groupIdValue}&emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            setGroupInfo(responseData?.dataJ[0]);
                        } else {
                            setGroupInfoError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setGroupInfoError(responseData?.info || 'Failed to fetch inventory data. Please try again.');
                    }
                } else {
                    setGroupInfoError(responseData?.info || 'Failed to fetch Task Categorie data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setGroupInfoError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setGroupInfoError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setGroupInfoError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setGroupInfoError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setGroupInfoError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Group Data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setGroupInfoError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setGroupInfoError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
            }
        } finally {
            setGroupInfoLoading(false);
        }
    }

    const fetchGstValueInfo = async () => {
        try {
            setGetValueInfoLoading(true);
            setGetValueInfoError('');
            setGetValueInfo({});


            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payload = {
                "action": "GET_CONFIG_TAX_INFO",
                "emp_id_auth": storedUserInfo?.emp_id,
                "series_for": "INVOICE"
            }

            // Make the API call
            const response = await postData(ORG_INVOICE, payload);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            setGetValueInfo(responseData?.dataJ[0]);
                            if (!responseData?.dataJ[0]?.series_type) {
                                setSubmitError('Service invoice series is not configured in settings.')
                            }
                            if (responseData?.dataJ[0]?.acc_tax_cgst == null) {
                                setCgstError('Unable to add CGST. CGST field is missing in Manage Tax')
                            }
                            if (responseData?.dataJ[0]?.acc_tax_sgst == null) {
                                setSgstError('Unable to add SGST. SGSTfield is missing in Manage Tax')
                            }
                            if (responseData?.dataJ[0]?.acc_tax_igst == null) {
                                setIgstError('Unable to add IGST. IGST field is missing in Manage Tax')
                            }
                            if (responseData?.dataJ[0]?.acc_tax_conv_fee == null) {
                                setConvFeeError('Unable to add Conveyance fee. Conveyance fee field is missing in Manage Tax')
                            }
                        } else {
                            setGetValueInfoError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setGetValueInfoError(responseData?.info || 'Failed to fetch GST data. Please try again.');
                    }
                } else {
                    setGetValueInfoError(responseData?.info || 'Failed to fetch GST data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setGetValueInfoError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setGetValueInfoError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setGetValueInfoError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setGetValueInfoError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            setGetValueInfoError(`Failed to fetch GST data. Please check your network connection and try again.`);

        } finally {
            setGetValueInfoLoading(false);
        }
    }

    const handleSetResponseData = async (resInvoiceInfo) => {
        console.log('resInvoiceInfo:--', resInvoiceInfo);
        setGetValueInfo({
            "series_type": resInvoiceInfo?.series_type,
            "acc_tax_sgst": resInvoiceInfo?.acc_tax_sgst,
            "acc_tax_cgst": resInvoiceInfo?.acc_tax_cgst,
            "acc_tax_igst": resInvoiceInfo?.acc_tax_igst,
            "acc_tax_conv_fee": resInvoiceInfo?.acc_tax_conv_fee
        })
        setIsCSGST(resInvoiceInfo?.is_acc_tax_cgst ? true : false);
        setIsIGST(resInvoiceInfo?.is_acc_tax_igst ? true : false);
        setIsConFee(resInvoiceInfo?.is_acc_tax_conv_fee ? true : false)

        setIsShowGroupWise(resInvoiceInfo?.invoice_for === 1 ? 'Client' : 'Group');
        setInvoiceWithoutTask(false);

        setSearchUser(resInvoiceInfo?.client_name);
        setSelectedClient(resInvoiceInfo);
        setSendUpdateToClient(resInvoiceInfo?.send_update_client);
        setSendUpdateToTeam(resInvoiceInfo?.send_update_team);

        setInvoiceDetails((prev) => ({
            ...prev,
            invoiceAmount: resInvoiceInfo?.invoice_amt_agreed || 0,
            systemInvoicingAmount: resInvoiceInfo?.invoice_amt_system || 0,
            invoiceType: { label: '', value: resInvoiceInfo?.recurring_type || 0 },
            noTaxInvoices: { label: '', value: resInvoiceInfo?.is_tax_invoice },
            generateSeperateInvoices: { label: resInvoiceInfo?.is_gen_seperate_invoice ? 'Yes' : 'No', value: resInvoiceInfo?.is_gen_seperate_invoice },
            advancePayments: resInvoiceInfo?.advance_amt || 0,
            generatedBy: { label: '', value: resInvoiceInfo?.invoice_gen_emp_id || 0 },
            followUpDate: resInvoiceInfo?.follow_up_date || '',
            cgst: resInvoiceInfo?.acc_tax_cgst_val || 0,
            sgst: resInvoiceInfo?.acc_tax_sgst_val || 0,
            igst: resInvoiceInfo?.acc_tax_igst_val || 0,
            conveyanceFee: resInvoiceInfo?.acc_tax_conv_fee_val || 0,
            discountAmount: resInvoiceInfo?.acc_discount_val || 0,
            discountAmountPct: resInvoiceInfo?.acc_discount || 0,
            grandTotal: resInvoiceInfo?.invoice_amt_total || 0,
            balanceAmt: resInvoiceInfo?.invoice_amt_bal || 0,
            invoiceNo: resInvoiceInfo?.recurring_id_gen || ''

        }));

        setBasicInformation((prev) => ({
            ...prev,
            dateOfInvoice: resInvoiceInfo?.recurring_create_at || '',
        }))


        if (resInvoiceInfo?.invoice_for === 1) {
            if (resInvoiceInfo?.invoice_type === 1) {
                const filterData = await convertResponseData(resInvoiceInfo?.service_category_names || [])
                setRows(filterData);
            } else {
                fetchTaskList(resInvoiceInfo?.client_id, resInvoiceInfo?.tasks_list);
            }
        } else {
            let groupInfo = { label: resInvoiceInfo?.group_name || '', value: resInvoiceInfo?.group_id || 0 }
            setGroupClient(groupInfo);
            fetchGroupInfo(resInvoiceInfo?.group_id);
            if (resInvoiceInfo?.invoice_type === 1) {
                const filterData = await convertResponseData(resInvoiceInfo?.service_category_names || [])
                setRows(filterData);
            } else {
                fetchGroupClientTaskList(resInvoiceInfo?.group_id, resInvoiceInfo?.tasks_list);
            }
        }



    }

    const convertResponseData = (data) => {
        return data?.map((item, index) => {
            // Call the function for each item
            let serviceId = { value: item?.service_id }
            fetchServiceCategoryList(serviceId, index);

            return {
                id: index,
                serviceCategory: {
                    label: item?.service_name,
                    value: item?.service_id
                },
                serviceType: item?.service_sub_details?.map((sub) => ({
                    label: sub?.service_sub_name,
                    value: sub?.service_sub_id
                })),
            };
        });
    };

    const processSelectedClientsTasks = (data) => {
        const groupedTasks = data?.reduce((acc, item) => {
            if (!acc[item?.client_id]) {
                acc[item?.client_id] = [];
            }
            acc[item?.client_id].push(item?.task_id);
            return acc;
        }, {});

        setSelectedClientsTasks(groupedTasks);
    };

    const handleInvoiceDetailsChange = (field, value) => {
        // Ensure the value is within valid range (0-100) and max 3 digits
        setDiscountError('')
        if (field === "discountAmountPct") {
            let percentage = value;
            if (percentage > 100) {
                setDiscountError('Discount cannot be more than 100.');
            }
            // if (percentage?.length > 3) percentage = percentage.slice(0, 3); // Limit to 3 digits

            // Calculate the discount amount
            const discountAmount = (Number(invoiceDetails?.invoiceAmount) * Number(percentage)) / 100;

            setInvoiceDetails((prevOptions) => ({
                ...prevOptions,
                discountAmountPct: percentage,
                discountAmount: parseFloat(discountAmount.toFixed(2)), // Ensure two decimal places
            }));
        } else {
            setInvoiceDetails((prevDetails) => ({
                ...prevDetails,
                [field]: value,
            }));
            // if (field === 'invoiceType') {
            setFiledErrors((prevDetails) => ({
                ...prevDetails,
                [field]: ''
            }));
            // }
        }

    };
    const handleShowIsClient = (value) => {
        setIsShowGroupWise(value);
        clearAllFileds();
    }
    const navigate = useNavigate()
    const handleBack = () => {
        // navigate(-1); // Navigate back to the previous page
        navigate('/bills-receipts', { state: { selectedTab: 2 } });
    };


    const getStatusStyle = (status) => {
        switch (status) {
            case "Not Started":
                return { backgroundColor: "rgba(226, 177, 51, 0.18)", color: "rgba(223, 165, 16, 1)" }; // Green
            case "Priority":
                return { backgroundColor: "rgba(238, 32, 28, 0.18)", color: "rgba(238, 32, 28, 1)" }; // Yellow
            case "Completed":
                return { backgroundColor: "#c7c4c32e", color: "#7b7b7b" }; 
            case "In Progress":
                return { backgroundColor: "rgba(26, 147, 46, 0.18)", color: "rgba(26, 147, 46, 1)" }; // Red
            default:
                return {};
        }
    };

    const handleSelectAll = (isChecked) => {
        setSelectAll(isChecked);
        // setCheckedStates(taskList.map(() => isChecked));
        // Update taskList to mark all as checked or unchecked
        const updatedTaskList = taskList.map((task) => ({
            ...task,
            checked: isChecked,
        }));
        setTaskList(updatedTaskList);
        setInvoiceDetails((prev) => ({
            ...prev,
            invoiceAmount: 0,
        }));

        if (isChecked) {
            // Add all task IDs to the selectedTaskIds list
            setSelectedTaskIds(taskList.map((task) => task.task_id));

            // Compute total estimated amount for all tasks
            const totalEstimatedAmount = taskList.reduce((sum, task) => sum + Number(task.invoice_amt_agreed || 0), 0);

            // Set invoiceAmount by adding all selected tasks
            setInvoiceDetails((prev) => ({
                ...prev,
                invoiceAmount: Number(prev.invoiceAmount) + Number(totalEstimatedAmount),
            }));
        } else {
            // Clear the selectedTaskIds list
            setSelectedTaskIds([]);

            // Reset invoiceAmount to 0 
            setInvoiceDetails((prev) => ({
                ...prev,
                invoiceAmount: 0,
            }));
        }
    };

    const handleCheckboxChange = (index, isChecked) => {
        setTaskListError('');
        const taskId = taskList[index]?.task_id;
        const taskBillAmountEstimated = taskList[index]?.invoice_amt_agreed || 0;

        // Update the checked status of the task
        const updatedTaskList = [...taskList];
        updatedTaskList[index] = { ...updatedTaskList[index], checked: isChecked };
        setTaskList(updatedTaskList);

        // Manage selected task IDs
        if (isChecked) {
            setSelectedTaskIds((prev) => [...prev, taskId]);
        } else {
            setSelectedTaskIds((prev) => prev.filter((id) => id !== taskId));
        }

        // Reset invoiceAmount to 0
        setInvoiceDetails((prev) => ({
            ...prev,
            invoiceAmount: 0,
        }));

        // Calculate the total of checked items' amounts
        const totalEstimateAmount = updatedTaskList
            .filter((task) => task.checked)
            .reduce((sum, task) => sum + Number(task.invoice_amt_agreed || 0), 0);

        // Update the invoiceDetails with the new total
        setInvoiceDetails((prev) => ({
            ...prev,
            invoiceAmount: totalEstimateAmount,
        }));

        // Check if all tasks are checked
        const allChecked = updatedTaskList.every((task) => task.checked);
        setSelectAll(allChecked);
    };

    // Client search code

    const handleSearchClient = async () => {
        try {
            setSelectedClientError('');
            setLoading(true);
            setClientList([]);
            if (!searchUser) {
                setSelectedClientError('Please enter client name'); return;
            }
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: searchUser }

            //console.log('team Data', payLoad);
            // Make the API call
            const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setClientList(responseData?.dataJ || []);
                    } else {
                        setSelectedClientError(responseData?.info || 'Failed to fetch Client. Please try again.');
                    }
                } else {
                    setSelectedClientError(responseData?.info || 'Failed to fetch Client.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setSelectedClientError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setSelectedClientError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setSelectedClientError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setSelectedClientError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            setSelectedClientError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);

        } finally {
            setLoading(false);
        }
    };


    const handleSearchInputText = (value) => {
        setSearchUser(value);
        setSelectedClientError('');
        setClientList([]);
        if (!value) {
            setSelectedClient(null);
        }

    }

    const handleSelectClient = (client) => {
        setSelectedClient(client); // Set selected client data
        setSearchUser(client?.client_name);
        fetchTaskList(client?.client_id, '');
        setClientList([]); // Clear the dropdown
        setSelectedClientError('');
    };

    const fetchTaskList = async (clientId, editTaskList) => {
        try {
            setTaskListError('');
            setTaskList([]);
            setSelectedTaskIds([]);
            setCheckedStates([]);
            setSelectAll(false);
            setTaskListLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_ESTIMATE_TASK_LIST}?emp_id_auth=${storedUserInfo?.emp_id}&client_id=${clientId}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            if (editTaskList?.length > 0) {
                                console.log('editTaskList:-', editTaskList)
                                const updatedTaskList = responseData?.dataJ.map((task) => ({
                                    ...task,
                                    checked: editTaskList.some((item) => item.task_id === task.task_id), // Set checked true if task_id exists in res
                                }));
                                setTaskList(updatedTaskList);
                                // Extract the task IDs of the checked items and update selectedTaskIds
                                const checkedTaskIds = updatedTaskList
                                    .filter((task) => task?.checked) // Get tasks with checked: true
                                    .map((task) => task?.task_id);  // Extract their task_id

                                setSelectedTaskIds(checkedTaskIds);
                                // Calculate the total of checked items' amounts
                                const totalEstimateAmount = updatedTaskList
                                    .filter((task) => task?.checked)
                                    .reduce((sum, task) => sum + Number(task.invoice_amt_agreed || 0), 0);

                                // Update the invoiceDetails with the new total
                                setInvoiceDetails((prev) => ({
                                    ...prev,
                                    invoiceAmount: totalEstimateAmount,
                                }));
                            } else {
                                setTaskList(responseData?.dataJ);
                            }
                        } else {
                            setTaskListError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setTaskListError(responseData?.info || 'Failed to fetch inventory data. Please try again.');
                    }
                } else {
                    setTaskListError(responseData?.info || 'Failed to fetch Task Categorie data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setTaskListError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setTaskListError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setTaskListError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setTaskListError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setTaskListError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setTaskListError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setTaskListError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
            }
        } finally {
            setTaskListLoading(false);
        }
    }

    // Group DropDown selection code 
    const fetchGroupList = async () => {
        try {
            setGroupClientError('')
            setGroupLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_GROUP_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            // Transforming the data
                            const filterData = responseData?.dataJ.map(service => ({
                                label: service?.group_name,
                                value: service?.group_id,
                                group_clients_count: service?.group_clients_count
                            }));
                            setGroupClientOptionsList(filterData)
                        } else {
                            setGroupClientError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setGroupClientError(responseData?.info || 'Failed to fetch group data. Please try again.');
                    }
                } else {
                    setGroupClientError(responseData?.info || 'Failed to fetchgroup data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                    setGroupClientError('Unauthorized access. Your session may have expired. Please log in again.');
            }
            else {
                setGroupClientError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            setGroupClientError(`Failed to fetch group data. Please check your network connection and try again.`);
         
        } finally {
            setGroupLoading(false);
        }
    }
    const handleSetGroupClient = (value) => {
        setGroupClient(value);
        setGroupClientError('');
        setGroupTaskList([]);
        setSelectedClientsTasks({});
        fetchGroupInfo(value?.value);
    }

    const showGroupInvoiceList = () => {
        setGroupClientError('');
        setTaskListError('')
        if (groupClient?.value) {
            fetchGroupClientTaskList(groupClient?.value, '');
        } else {
            setGroupClientError('Select group')
        }
    }

    const fetchGroupClientTaskList = async (groupId, editTaskList) => {
        try {
            // setIsShowGroupWise(true)
            setGroupTaskListError('');
            setGroupTaskList([]);
            setSelectedClientsTasks({});
            setGroupTaskListLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_GROUP_ESTIMATE_TASK_LIST}?emp_id_auth=${storedUserInfo?.emp_id}&group_id=${groupId}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            setGroupTaskList(responseData?.dataJ);
                            if (editTaskList) {
                                processSelectedClientsTasks(editTaskList);
                            }
                        } else {
                            setGroupTaskListError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setGroupTaskListError(responseData?.info || 'Failed to fetch inventory data. Please try again.');
                    }
                } else {
                    setGroupTaskListError(responseData?.info || 'Failed to fetch Task Categorie data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setGroupTaskListError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setGroupTaskListError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setGroupTaskListError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setGroupTaskListError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setGroupTaskListError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setGroupTaskListError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setGroupTaskListError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
            }
        } finally {
            setGroupTaskListLoading(false);
        }
    }



    // Handle Task Checkbox Selection
    const handleTaskCheckboxChange = (clientId, taskId, taskEstimatedAmount, isChecked) => {
        setSelectedClientsTasks((prev) => {
            const prevSelected = prev[clientId] || [];
            return {
                ...prev,
                [clientId]: isChecked ? [...prevSelected, taskId] : prevSelected.filter((id) => id !== taskId),
            };
        });

        // Reset setInvoice to 0
        setInvoiceDetails((prev) => ({
            ...prev,
            invoiceAmount: 0,
        }));

        // Update Estimate Amount based on all checked tasks
        setSelectedClientsTasks((prevSelected) => {
            const selectedTasks = Object.values(prevSelected).flat();
            const totalEstimateAmount = groupTaskList
                .flatMap(client => client.task_list)
                .filter(task => selectedTasks.includes(task.task_id))
                .reduce((sum, task) => sum + Number(task.invoice_amt_agreed || 0), 0);

            setInvoiceDetails((prev) => ({
                ...prev,
                invoiceAmount: totalEstimateAmount,
            }));

            return prevSelected;
        });
    };

    // Handle Select All for Client
    const handleClientSelectAll = (clientId, isChecked) => {
        const clientTasks = groupTaskList.find(client => client.client_id === clientId)?.task_list || [];
        const allTaskIds = clientTasks.map(task => task.task_id);

        setSelectedClientsTasks((prev) => ({
            ...prev,
            [clientId]: isChecked ? allTaskIds : [], // Select or Deselect all
        }));

        // Reset invoiceAmount to 0
        setInvoiceDetails((prev) => ({
            ...prev,
            invoiceAmount: 0,
        }));

        // Update Estimate Amount based on all checked tasks
        setSelectedClientsTasks((prevSelected) => {
            const selectedTasks = Object.values(prevSelected).flat();
            const totalEstimateAmount = groupTaskList
                .flatMap(client => client.task_list)
                .filter(task => selectedTasks.includes(task.task_id))
                .reduce((sum, task) => sum + Number(task.invoice_amt_agreed || 0), 0);

            setInvoiceDetails((prev) => ({
                ...prev,
                invoiceAmount: totalEstimateAmount,
            }));

            return prevSelected;
        });
    };
    // Toggle Client Expansion
    const toggleClient = (clientId) => {
        setExpandedClients((prev) => ({ ...prev, [clientId]: !prev[clientId] }));
    };


    // Employees list 
    const fetchUserList = async () => {
        try {
            setEmpLoading(true);
            setEmpError('');
            setEmployeeList([]);


            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_EMPLOYEE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            const filterData = responseData?.dataJ.map(service => ({
                                label: service?.emp_name,
                                value: service?.emp_id
                            }));
                            setEmployeeList(filterData);
                        } else {
                            setEmpError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setEmpError(responseData?.info || 'Failed to fetch User data. Please try again.');
                    }
                } else {
                    setEmpError(responseData?.info || 'Failed to fetch User data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setEmpError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setEmpError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setEmpError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setEmpError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setEmpError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch User data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setEmpError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setEmpError(`Failed to fetch User data. Please check your network connection and try again.`);
            }
        } finally {
            setEmpLoading(false);
        }
    }
    // service list 

    const fetchServiceList = async () => {
        try {
            setServiceError('');
            setServiceLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
                "emp_id_auth": storedUserInfo?.emp_id
            }

            //console.log('fetchTaskCategorieList payload', payLoad);

            // Make the API call
            const response = await postData(ORG_GET_SERVICE_LIST_SEARCH, payLoad);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            // Transforming the data
                            const filterData = responseData?.dataJ.map(service => ({
                                label: service.service_name,
                                value: service.service_id
                            }));
                            setServiceOptions(filterData)
                        } else {
                            setServiceError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setServiceError(responseData?.info || 'Failed to fetch inventory data. Please try again.');
                    }
                } else {
                    setServiceError(responseData?.info || 'Failed to fetch Task Categorie data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setServiceError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setServiceError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setServiceError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setServiceError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setServiceError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setServiceError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setServiceError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
            }
        } finally {
            setServiceLoading(false);
        }
    }

    const fetchServiceCategoryList = async (serviceId, rowId) => {
        try {
            setServiceCategoryError({});
            setServiceCategoryLoading((prev) => ({ ...prev, [rowId]: true }));
            setServiceCategoryOptions((prev) => ({ ...prev, [rowId]: [] }));
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
                "emp_id_auth": storedUserInfo?.emp_id,
                "service_id": serviceId?.value || 0
            }

            //console.log('--fetchTaskSubCategorieList payload--', payLoad);

            // Make the API call service_id=10006&
            const response = await postData(ORG_GET_SUB_SERVICE_LIST_SEARCH, payLoad);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            // Transforming the data
                            const filterData = responseData?.dataJ.map(service => ({
                                label: service.service_sub_name,
                                value: service.service_sub_id
                            }));
                            setServiceCategoryOptions((prev) => ({ ...prev, [rowId]: filterData })); // Store per row
                        } else {
                            setServiceCategoryError((prev) => ({ ...prev, [rowId]: responseData?.info || 'Data Not Found' }));
                        }
                    } else {
                        setServiceCategoryError((prev) => ({ ...prev, [rowId]: responseData?.info || 'Failed to fetch inventory data. Please try again.' }));
                    }
                } else {
                    setServiceCategoryError((prev) => ({ ...prev, [rowId]: responseData?.info || 'Failed to fetch Task Categorie data.' }));
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setServiceCategoryError((prev) => ({ ...prev, [rowId]: 'Unauthorized access. Your session may have expired. Please log in again.' }));
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setServiceCategoryError((prev) => ({ ...prev, [rowId]: responseData?.info || 'Bad request. Please check the request parameters.' }));
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setServiceCategoryError((prev) => ({ ...prev, [rowId]: responseData?.info || 'Internal Server Error. Please try again later.' }));
            }
            // Unexpected or network-related errors
            else {
                setServiceCategoryError((prev) => ({ ...prev, [rowId]: 'Unexpected error occurred. Please try again later.' }));
            }
        } catch (error) {

            setServiceCategoryError((prev) => ({ ...prev, [rowId]: 'Failed to fetch Task Categorie data. Please check your network connection and try again.' }));

        } finally {
            setServiceCategoryLoading((prev) => ({ ...prev, [rowId]: false }));
        }
    }


    const handleSelectServiceOrTask = (value) => {
        if (rowData) { return }
        setInvoiceWithoutTask(value);

        if (isShowGroupWise === 'Group') {
            setSelectedClientsTasks({});
        } else {
            setCheckedStates([]);
            setSelectedTaskIds([]);
            handleSelectAll(false);
        }
        setRows([{ id: 1, serviceCategory: null, serviceType: [] }]);
        setInvoiceDetails((prev) => ({
            ...prev,
            invoiceAmount: 0,
        }));
    }

    // Function to add a new service row
    const addServiceRow = () => {
        setRows([...rows, { id: Date.now(), serviceCategory: null, serviceType: [] }]);
    };

    // Function to remove a service row
    const removeServiceRow = (id) => {
        setRows(rows.filter((row) => row.id !== id));
    };


    const handleSubmitInvoice = async () => {
        try {
            setSubmitError('');
            setGroupClientError('');
            setSelectedClientError('');
            setTaskListError('');
            setServiceSelectError('');
            setDateError('');
            setFiledErrors({
                invoiceType: "",
                systemInvoicingAmount: "",
                invoiceAmount: "",
                noTaxInvoices: "",
                followUpDate: "",
                invoiceNo: "",
            })

            //  Extract all Clents task IDs into a single list
            const allTaskIds = Object.values(selectedClientsTasks).flat();

            const servicesListSelected = rows
                .filter(item => item.serviceCategory?.value) // Filter out items without serviceCategory value
                .map(item => ({
                    service_id: item.serviceCategory.value, // Use serviceCategory value as service_id
                    service_sub_list: item.serviceType ? item.serviceType.map(type => type.value) : [] // Map serviceType values
                }));

            let hasError = false;

            if (isShowGroupWise === 'Group') {
                if (!groupClient?.value) {
                    setGroupClientError('Select group name.'); hasError = true
                }
                if (!basicInformation?.dateOfInvoice) {
                    setDateError('Please select date'); hasError = true
                }
                if (invoiceWithoutTask) {
                    if (allTaskIds.length <= 0) {
                        setTaskListError('Please select at least one task.'); hasError = true
                    }

                } else {
                    if (servicesListSelected.length <= 0) {
                        setServiceSelectError('Please select requested services'); hasError = true
                    }
                    // Check if any serviceType is empty
                    const hasEmptyServiceType = servicesListSelected.some(
                        (service) => service.service_sub_list.length === 0
                    );
                    console.log('hasEmptyServiceType:', hasEmptyServiceType)

                    if (hasEmptyServiceType) {
                        setServiceSelectError('Please select at least one service category for service');
                        hasError = true
                    }
                    if (!invoiceDetails?.invoiceType?.value) {
                        setFiledErrors((prev) => ({
                            ...prev,
                            invoiceType: "Invoice type is required.",
                        })); hasError = true
                    }
                }


            } else {
                if (!selectedClient?.client_id) {
                    setSelectedClientError('Enter client name, search, and select.'); hasError = true
                }
                if (!basicInformation?.dateOfInvoice) {
                    setDateError('Please select date'); hasError = true
                }
                if (invoiceWithoutTask) {
                    if (selectedTaskIds.length <= 0) {
                        setTaskListError('Please select at least one task.'); hasError = true
                    }

                } else {
                    if (servicesListSelected.length <= 0) {
                        setServiceSelectError('Please select requested services'); hasError = true
                    }
                    // Check if any serviceType is empty
                    const hasEmptyServiceType = servicesListSelected.some(
                        (service) => service.service_sub_list.length === 0
                    );
                    console.log('hasEmptyServiceType:', hasEmptyServiceType)

                    if (hasEmptyServiceType) {
                        setServiceSelectError('Please select at least one service category for service');
                        hasError = true
                    }
                    if (!invoiceDetails?.invoiceType?.value) {
                        setFiledErrors((prev) => ({
                            ...prev,
                            invoiceType: "Invoice type is required.",
                        })); hasError = true
                    }
                }
            }

  

            if (!invoiceDetails?.systemInvoicingAmount) {
                setFiledErrors((prev) => ({
                    ...prev,
                    systemInvoicingAmount: "System invoicing amount is required.",
                })); hasError = true
            }

            if (!invoiceDetails?.invoiceAmount) {
                setFiledErrors((prev) => ({
                    ...prev,
                    invoiceAmount: "Invoice amount is required.",
                })); hasError = true
            }

            if (!invoiceDetails?.generatedBy) {
                setFiledErrors((prev) => ({
                    ...prev,
                    generatedBy: "Generated by is required.",
                })); hasError = true
            }

            if (!invoiceDetails?.followUpDate) {
                setFiledErrors((prev) => ({
                    ...prev,
                    followUpDate: "Follow-up date is required.",
                })); hasError = true
            }

            if (hasError) {
                return
            }
            if (invoiceDetails?.discountAmountPct) {
                if (invoiceDetails?.discountAmountPct > 100) {
                    setDiscountError('Discount cannot be more than 100.'); return
                }
            }
            setSubmitLoading(true)
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad =
            {
                "emp_id_auth": storedUserInfo?.emp_id,
                "client_id": selectedClient?.client_id || 0,
                "recurring_create_at": formatDateToISO(basicInformation?.dateOfInvoice),
                "follow_up_date": invoiceDetails?.followUpDate.replace('T', ' ') + ' 00:00:00' || '',
                "group_id": groupClient?.value || 0,
                "is_recurring_active": 1,
                "invoice_gen_emp_id": invoiceDetails?.generatedBy?.value || '',
                "is_group_invoice": isShowGroupWise === 'Group' ? 1: 0,
                "invoice_for": isShowGroupWise === 'Group' ? 2 : 1,
                "invoice_type": invoiceWithoutTask ? 2 : 1,
                "invoice_amt_system": invoiceDetails?.systemInvoicingAmount || 0,
                "invoice_amt_agreed": invoiceDetails?.invoiceAmount || 0,
                "send_update_client": sendUpdateToClient ? 1 : 0,
                "send_update_team": sendUpdateToTeam ? 1 : 0,
                "is_tax_invoice": invoiceDetails?.noTaxInvoices?.value || 0,
                "is_gen_seperate_invoice": invoiceDetails?.generateSeperateInvoices?.value || 0,
                "recurring_type":invoiceDetails?.invoiceType?.value || 0,
                "service_category_names": !invoiceWithoutTask ? servicesListSelected : [],
                "recurring_id_gen": getValueInfo?.series_type === 1 ? invoiceDetails?.invoiceNo : '',
                "invoice_amt_total": invoiceDetails?.grandTotal || 0,
                "invoice_amt_bal": invoiceDetails?.balanceAmt || 0,
                "acc_discount": invoiceDetails?.discountAmountPct || 0,
                "acc_discount_val": invoiceDetails?.discountAmount || 0,

                "series_type": getValueInfo?.series_type || 0,

                "acc_tax_sgst": getValueInfo?.acc_tax_sgst || 0,
                "acc_tax_cgst": getValueInfo?.acc_tax_cgst || 0,
                "acc_tax_igst": getValueInfo?.acc_tax_igst || 0,
                "acc_tax_conv_fee": getValueInfo?.acc_tax_conv_fee || 0,

                "acc_tax_sgst_val": invoiceDetails?.sgst || 0,
                "acc_tax_cgst_val": invoiceDetails?.cgst || 0,
                "acc_tax_igst_val": invoiceDetails?.igst || 0,
                "acc_tax_conv_fee_val": invoiceDetails?.conveyanceFee || 0,

                "is_acc_tax_cgst": isCSGST ? 1 : 0,
                "is_acc_tax_igst": isIGST ? 1 : 0,
                "is_acc_tax_conv_fee": isConFee ? 1 : 0,

                "action": 'add_recurring_inv'
            }

            console.log('payload:--', payLoad);
            // Make the API call service_id=10006&
            const response = await postData(ORG_CREATE_RECURRUNG_INVOICE, payLoad);
            const responseData = await response.json();
            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setSubmitSuccess(responseData?.info || '');
                        clearAllFileds()
                        setTimeout(() => {
                            setSubmitSuccess('');
                            navigate('/bills-receipts', { state: { selectedTab: 2 } });
                        }, 3000);
                    } else {
                        setSubmitError(responseData?.info || 'Failed to create estimate. Please try again.');
                    }
                } else {
                    setSubmitError(responseData?.info || 'Failed to create estimate.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setSubmitError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setSubmitError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setSubmitError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setSubmitError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            setSubmitError('No response received from the server. Please check your network connection and try again.');
        } finally {
            setSubmitLoading(false)
        }


    }
    const formatDateToISO = (dateString) => {
        // Check if the date is in dd/MM format using regex
        const ddMMRegex = /^\d{2}\/\d{2}$/;
      
        if (ddMMRegex.test(dateString)) {
          // Split the dateString to extract day and month
          const [day, month] = dateString.split("/");
      
          // Get the current year dynamically
          const currentYear = new Date().getFullYear();
      
          // Create the formatted string as YYYY-MM-DD 00:00:00
          return `${currentYear}-${month}-${day} 00:00:00`;
        }
      
        // Return the original dateString if it's not in dd/MM format
        return dateString;
      };

    const clearAllFileds = () => {
        setSelectAll(false);
        setCheckedStates([]);
        setSelectedTaskIds([]);
        setSendUpdateToClient(false);
        setSendUpdateToTeam(false);
        setInvoiceWithoutTask(false);
        setSearchUser('');
        setClientList([]);
        setSelectedClient(null);
        setSelectedClientError('');
        setLoading(false);
        setGroupLoading(false);
        setGroupClientError('');
        setGroupClient(null);
        setTaskListLoading(false);
        setTaskList([]);
        setTaskListError('');
        setDateError('');
        setEmpLoading(false);
        setEmpError('');
        setSubmitLoading(false);
        setSubmitError('');
        setServiceSelectError('');
        setGroupTaskListLoading(false);
        setGroupTaskListError('');
        setExpandedClients({});
        setRows([{ id: 1, serviceCategory: null, serviceType: [] }]);
        setServiceError('');
        setServiceLoading(false);
        setServiceCategoryOptions({});
        setServiceCategoryError({});
        setServiceCategoryLoading({});

        setSelectedClientsTasks({});
        setGroupTaskList([]);
        setBasicInformation((prevInfo) => ({
            ...prevInfo,
            dateOfInvoice: '',
        }));
        setGroupInfo({})

    }

    const handleGenReceiptConfirmModal = () => {
        setIsGenReceiptModalOpen(true);
    }

    const handleCloseGenReceiptModal = () => {
        setIsGenReceiptModalOpen(false); // Close the modal
    };

    const handleGenerateReceipt = () => {
        const prepReceiptData = {
            searchInvoice: rowData?.recurring_id_gen || '',
            advancePayment: 0,
            clientId: 0
        }
        navigate('/generate-edit-receipt', { state: { prepReceiptData: prepReceiptData } });
    }

    const handleUpdateInvoice = async () => {
        try {
            setSubmitError('');
            setGroupClientError('');
            setSelectedClientError('');
            setTaskListError('');
            setServiceSelectError('');
            setDateError('');
            setFiledErrors({
                invoiceType: "",
                systemInvoicingAmount: "",
                invoiceAmount: "",
                noTaxInvoices: "",
                followUpDate: "",
                invoiceNo: "",
            })

            //  Extract all Clents task IDs into a single list
            const allTaskIds = Object.values(selectedClientsTasks).flat();

            const servicesListSelected = rows
                .filter(item => item.serviceCategory?.value) // Filter out items without serviceCategory value
                .map(item => ({
                    service_id: item.serviceCategory.value, // Use serviceCategory value as service_id
                    service_sub_list: item.serviceType ? item.serviceType.map(type => type.value) : [] // Map serviceType values
                }));

            let hasError = false;

            if (isShowGroupWise === 'Group') {
                if (!groupClient?.value) {
                    setGroupClientError('Select group name.'); hasError = true
                }
                if (!basicInformation?.dateOfInvoice) {
                    setDateError('Please select date'); hasError = true
                }
                if (invoiceWithoutTask) {
                    if (allTaskIds.length <= 0) {
                        setTaskListError('Please select at least one task.'); hasError = true
                    }

                } else {
                    if (servicesListSelected.length <= 0) {
                        setServiceSelectError('Please select requested services'); hasError = true
                    }
                    // Check if any serviceType is empty
                    const hasEmptyServiceType = servicesListSelected.some(
                        (service) => service.service_sub_list.length === 0
                    );
                    console.log('hasEmptyServiceType:', hasEmptyServiceType)

                    if (hasEmptyServiceType) {
                        setServiceSelectError('Please select at least one service category for service');
                        return
                    }
                    if (!invoiceDetails?.invoiceType?.value) {
                        setFiledErrors((prev) => ({
                            ...prev,
                            invoiceType: "Invoice type is required.",
                        })); hasError = true
                    }
                }

            } else {
                if (!selectedClient?.client_id) {
                    setSelectedClientError('Enter client name, search, and select.'); hasError = true
                }
                if (!basicInformation?.dateOfInvoice) {
                    setDateError('Please select date'); hasError = true
                }
                if (invoiceWithoutTask) {
                    if (selectedTaskIds.length <= 0) {
                        setTaskListError('Please select at least one task.'); hasError = true
                    }

                } else {
                    if (servicesListSelected.length <= 0) {
                        setServiceSelectError('Please select requested services'); hasError = true
                    }
                    // Check if any serviceType is empty
                    const hasEmptyServiceType = servicesListSelected.some(
                        (service) => service.service_sub_list.length === 0
                    );
                    console.log('hasEmptyServiceType:', hasEmptyServiceType)

                    if (hasEmptyServiceType) {
                        setServiceSelectError('Please select at least one service category for service');
                        return
                    }
                    if (!invoiceDetails?.invoiceType?.value) {
                        setFiledErrors((prev) => ({
                            ...prev,
                            invoiceType: "Invoice type is required.",
                        })); hasError = true
                    }
                }
            }

            if (!invoiceDetails?.systemInvoicingAmount) {
                setFiledErrors((prev) => ({
                    ...prev,
                    systemInvoicingAmount: "System invoicing amount is required.",
                })); hasError = true
            }

            if (!invoiceDetails?.invoiceAmount) {
                setFiledErrors((prev) => ({
                    ...prev,
                    invoiceAmount: "Invoice amount is required.",
                })); hasError = true
            }

            if (!invoiceDetails?.followUpDate) {
                setFiledErrors((prev) => ({
                    ...prev,
                    followUpDate: "Follow-up date is required.",
                })); hasError = true
            }

            if (hasError) {
                return
            }
            if (invoiceDetails?.discountAmountPct) {
                if (invoiceDetails?.discountAmountPct > 100) {
                    setDiscountError('Discount cannot be more than 100.'); return
                }
            }
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad =
            {
                "emp_id_auth": storedUserInfo?.emp_id,
                "client_id": selectedClient?.client_id || 0,
                "recurring_id": rowData?.recurring_id || 0,
                "recurring_create_at": formatDateToISO(basicInformation?.dateOfInvoice),
                "follow_up_date": invoiceDetails?.followUpDate.replace('T', ' ') + ' 00:00:00' || '',
                "group_id": groupClient?.value || 0,
                "is_recurring_active": invoiceInfo?.is_recurring_active,
                "invoice_gen_emp_id": invoiceDetails?.generatedBy?.value || '',
                "is_group_invoice": isShowGroupWise === 'Group' ? 1: 0,
                "invoice_for": isShowGroupWise === 'Group' ? 2 : 1,
                "invoice_type": invoiceWithoutTask ? 2 : 1,
                "invoice_amt_system": invoiceDetails?.systemInvoicingAmount || 0,
                "invoice_amt_agreed": invoiceDetails?.invoiceAmount || 0,
                "send_update_client": sendUpdateToClient ? 1 : 0,
                "send_update_team": sendUpdateToTeam ? 1 : 0,
                "is_tax_invoice": invoiceDetails?.noTaxInvoices?.value || 0,
                "is_gen_seperate_invoice": invoiceDetails?.generateSeperateInvoices?.value || 0,
                "recurring_type":invoiceDetails?.invoiceType?.value || 0,
                "service_category_names": !invoiceWithoutTask ? servicesListSelected : [],
                "recurring_id_gen": getValueInfo?.series_type === 1 ? invoiceDetails?.invoiceNo : '',
                "invoice_amt_total": invoiceDetails?.grandTotal || 0,
                "invoice_amt_bal": invoiceDetails?.balanceAmt || 0,
                "acc_discount": invoiceDetails?.discountAmountPct || 0,
                "acc_discount_val": invoiceDetails?.discountAmount || 0,
                "series_type": getValueInfo?.series_type || 0,
                "acc_tax_sgst": getValueInfo?.acc_tax_sgst || 0,
                "acc_tax_cgst": getValueInfo?.acc_tax_cgst || 0,
                "acc_tax_igst": getValueInfo?.acc_tax_igst || 0,
                "acc_tax_conv_fee": getValueInfo?.acc_tax_conv_fee || 0,

                "acc_tax_sgst_val": invoiceDetails?.sgst || 0,
                "acc_tax_cgst_val": invoiceDetails?.cgst || 0,
                "acc_tax_igst_val": invoiceDetails?.igst || 0,
                "acc_tax_conv_fee_val": invoiceDetails?.conveyanceFee || 0,

                "is_acc_tax_cgst": isCSGST ? 1 : 0,
                "is_acc_tax_igst": isIGST ? 1 : 0,
                "is_acc_tax_conv_fee": isConFee ? 1 : 0,

                "action": 'update_recurring_inv'

            }

            console.log('update payload:--', payLoad);
            setSubmitLoading(true)
            // Make the API call service_id=10006&
            const response = await postData(ORG_CREATE_RECURRUNG_INVOICE, payLoad);
            const responseData = await response.json();
            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setSubmitSuccess(responseData?.info || '');
                        setTimeout(() => {
                            setSubmitSuccess('');
                            navigate('/bills-receipts', { state: { selectedTab: 2 } });
                        }, 3000);
                    } else {
                        setSubmitError(responseData?.info || 'Failed to reciepts_info. Please try again.');
                    }
                } else {
                    setSubmitError(responseData?.info || 'Failed to update invoice.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                 setSubmitError('Unauthorized access. Your session may have expired. Please log in again.');
               
            }
            else {
                setSubmitError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            setSubmitError('No response received from the server. Please check your network connection and try again.');
        } finally {
            setSubmitLoading(false)
        }
    }

    const handleToSetPreSelectedData = async (preData) => {
        console.log('resInvoiceInfo:--', preData);
        try {
            setIsShowGroupWise(preData?.estimate_for || '');
            setInvoiceWithoutTask(false);

            setSearchUser(preData?.clientSelectedInfo?.client_name);
            setSelectedClient(preData?.clientSelectedInfo);
            setSendUpdateToClient(preData?.send_update_client);
            setSendUpdateToTeam(preData?.send_update_team);

            setInvoiceDetails((prev) => ({
                ...prev,
                invoiceAmount: preData?.estimateAmount || 0,
                systemInvoicingAmount: preData?.systemBillingAmount || 0,
                generateSeperateInvoices: preData?.groupEstimate || null,
                generatedBy: preData?.generatedBy || null,
                estimateNumber: preData?.estimate_id_gen || 0
            }));

            // setBasicInformation((prev) => ({
            //     ...prev,
            //     dateOfInvoice: preData?.recurring_create_at || '',
            // }))


            if (preData?.estimate_for === 'Client') {
                if (!preData?.estimate_type) {
                    await callSubServiceApis(preData?.service_category_names)
                    setRows(preData?.service_category_names || []);
                } else {
                    setTaskList(preData?.taskList || []);
                    setSelectedTaskIds(preData?.tasks_list_selected || [])
                }
            } else {
                setGroupClient(preData?.groupClient || null);
                setGroupInfo(preData?.groupInfo || null)
                if (!preData?.estimate_type) {
                    await callSubServiceApis(preData?.service_category_names)
                    setRows(preData?.service_category_names || []);
                } else {
                    setGroupTaskList(preData?.groupTaskList || []);
                    setSelectedClientsTasks(preData?.tasks_list_selected || {})
                }
            }
        } catch (error) {
            console.log('error predata:-', error)
        }
    }

    const handleTaskListPageData = (preData) => {
        console.log('preData:-', preData)

        setIsShowGroupWise(preData?.estimate_for || '');
        setInvoiceWithoutTask(false);

        setSearchUser(preData?.clientSelectedInfo?.client_name);
        setSelectedClient(preData?.clientSelectedInfo);
        setSendUpdateToClient(preData?.send_update_client);
        setSendUpdateToTeam(preData?.send_update_team);
        setSelectedTaskIds(preData?.tasks_list_selected || [])
        fetchTaskList(preData?.clientSelectedInfo?.client_id, preData?.tasks_list_selected || []);
    }

    const callSubServiceApis = (data) => {
        // console.log('data sub:-', data)
        return data?.map((item, index) => {
            let serviceId = { value: item?.serviceCategory?.value }
            fetchServiceCategoryList(serviceId, item?.id);

        });
    };

    useEffect(() => {
        console.log('invoiceDetails?.advancePayments:-', invoiceDetails?.advancePayments);
        if (invoiceDetails?.advancePayments) {
            setInvoiceDetails((prev) => ({
                ...prev,
                balanceAmt: Number(
                    (Number(prev.grandTotal) - Number(invoiceDetails?.advancePayments)).toFixed(2) // Round to 2 decimal places
                )
            }));
        } else {
            setInvoiceDetails((prev) => ({
                ...prev,
                balanceAmt: Number(
                    (Number(prev.grandTotal)).toFixed(2) // Round to 2 decimal places
                )
            }));
        }


    }, [invoiceDetails?.advancePayments, invoiceDetails?.grandTotal])

    useEffect(() => {
        console.log('estmate ammount', invoiceDetails?.invoiceAmount)
        if (invoiceDetails?.invoiceAmount) {
            handleGSTCalculations(invoiceDetails?.invoiceAmount, 'estimateAmt')
        } else {
            handleGSTCalculations(0, 'estimateAmt')
        }

    }, [invoiceDetails?.invoiceAmount, invoiceDetails?.discountAmount])

    useEffect(() => {
        setTimeout(() => {
            handleInvoiceDetailsChange('discountAmountPct', invoiceDetails?.discountAmountPct)
        }, 200);
    }, [invoiceDetails?.invoiceAmount])



    const handleGSTCalculations = (value, type) => {
        console.log('is checked:-', value);
        let updatedValues = {
            cgst: invoiceDetails?.cgst,
            sgst: invoiceDetails?.sgst,
            igst: invoiceDetails?.igst,
            conveyanceFee: invoiceDetails?.conveyanceFee,
            discountAmount: invoiceDetails?.discountAmount
        };

        const netInvoiceAmount = Number(invoiceDetails?.invoiceAmount || 0) - Number(invoiceDetails?.discountAmount || 0);

        if (type === 'cgst') {
            setIsCSGST(value);
            if (value) {
                setIsIGST(false);
                updatedValues.igst = 0;
            }
            updatedValues.cgst = value ? (netInvoiceAmount * Number(getValueInfo?.acc_tax_cgst || 0) / 100).toFixed(2) : 0;
            updatedValues.sgst = value ? (netInvoiceAmount * Number(getValueInfo?.acc_tax_sgst || 0) / 100).toFixed(2) : 0;
            updatedValues.conveyanceFee = isConFee
                ? ((netInvoiceAmount + (value ? Number(updatedValues.cgst) + Number(updatedValues.sgst) : 0)) * Number(getValueInfo?.acc_tax_conv_fee || 0) / 100).toFixed(2)
                : 0;
        } else if (type === 'igst') {
            setIsIGST(value);
            if (value) {
                setIsCSGST(false);
                updatedValues.cgst = 0;
                updatedValues.sgst = 0;
            }
            updatedValues.igst = value ? (netInvoiceAmount * Number(getValueInfo?.acc_tax_igst || 0) / 100).toFixed(2) : 0;
            updatedValues.conveyanceFee = isConFee
                ? ((netInvoiceAmount + (value ? Number(updatedValues.igst) : 0)) * Number(getValueInfo?.acc_tax_conv_fee || 0) / 100).toFixed(2)
                : 0;
        } else if (type === 'fee') {
            setIsConFee(value);
            updatedValues.conveyanceFee = value
                ? ((netInvoiceAmount + (isCSGST ? Number(updatedValues.cgst) + Number(updatedValues.sgst) : 0) + (isIGST ? Number(updatedValues.igst) : 0)) * Number(getValueInfo?.acc_tax_conv_fee || 0) / 100).toFixed(2)
                : 0;
        } else if (type === 'estimateAmt') {
            updatedValues.cgst = isCSGST ? (netInvoiceAmount * Number(getValueInfo?.acc_tax_cgst || 0) / 100).toFixed(2) : 0;
            updatedValues.sgst = isCSGST ? (netInvoiceAmount * Number(getValueInfo?.acc_tax_sgst || 0) / 100).toFixed(2) : 0;
            updatedValues.igst = isIGST ? (netInvoiceAmount * Number(getValueInfo?.acc_tax_igst || 0) / 100).toFixed(2) : 0;
            updatedValues.conveyanceFee = isConFee
                ? ((netInvoiceAmount + Number(updatedValues.cgst) + Number(updatedValues.sgst)) * Number(getValueInfo?.acc_tax_conv_fee || 0) / 100).toFixed(2)
                : 0;
        } else if (type === 'discount') {
            // updatedValues.discountAmount = Number(value) || 0;
        }

        setInvoiceDetails((prev) => ({
            ...prev,
            ...updatedValues,
            grandTotal: Number(
                (
                    netInvoiceAmount +
                    Number(updatedValues.cgst) + Number(updatedValues.sgst) +
                    Number(updatedValues.igst) + Number(updatedValues.conveyanceFee)
                ).toFixed(2)
            )
        }));
    };
    const handleUserToggleChange =(value)=>{
        setInvoiceInfo((prev) => ({
            ...prev,
            is_recurring_active: value ? 1:0
        }))
        console.log('handleUserToggleChange')
    }


    return {
        basicInformation, rowData,
        setBasicInformation,
        handleBasicInformationChange,
        invoiceTableData,
        invoiceDetails,
        setInvoiceDetails,
        handleInvoiceDetailsChange,
        sendUpdateToClient,
        setSendUpdateToClient, handleBack,
        sendUpdateToTeam, getStatusStyle, selectAll, checkedStates,
        setSendUpdateToTeam, handleCheckboxChange, handleSelectAll,
        handleShowIsClient, isShowGroupWise,
        handleSelectClient,
        handleSearchInputText,
        handleSearchClient,
        searchUser,
        selectedClientError,
        clientList,
        loading,
        groupClientOptionsList,
        groupLoading,
        groupClientError, selectedClient,
        groupClient, showGroupInvoiceList, handleSetGroupClient,
        groupTaskListLoading, groupTaskList, groupTaskListError, dateError,
        taskListLoading, taskList, taskListError, selectedClientsTasks,
        handleClientSelectAll, handleTaskCheckboxChange, toggleClient, expandedClients,
        employeeList, empLoading, empError, invoiceWithoutTask,
        handleSelectServiceOrTask, removeServiceRow, addServiceRow, rows, setRows,
        fetchServiceCategoryList, serviceCategoryOptions, serviceOptions,
        serviceCategoryError, serviceCategoryLoading, serviceError, serviceLoading,
        serviceSelectError, submitLoading, submitError, submitSuccess, handleSubmitInvoice, filedErrors,
        handleGenerateReceipt, invoiceLoading, invoiceError, groupInfo, handleUpdateInvoice,
        isGenReceiptModalOpen, handleCloseGenReceiptModal, handleGenReceiptConfirmModal,
        handleGSTCalculations, isIGST, isCSGST, discountError, invoiceInfo,isRecurring,handleUserToggleChange,
        isConFee, getValueInfo, getValueInfoError, gstValueInfoLoading, convFeeError, igstError, sgstError, cgstError
    }
}

export default GenerateRecurringInvoiceController